// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { OperatorConfiguration } from '@daml.js/dtc-registry-app/lib/Dtc/Registry/App/V3/Configuration/Operator';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import { useParties } from '../../../../contexts/PartiesContext';
import TemplateContract from '../../../../utils/TemplateContract';
import { useLedgerEnd } from '../../ledger/useLedgerEnd';

const useRegistryOperatorConfiguration: () => UseQueryResult<
  TemplateContract<OperatorConfiguration> | null,
  string
> = () => {
  const ledgerApi = useLedgerApiClient();
  const { operator } = useParties();
  const offset = useLedgerEnd();
  return useQuery({
    queryKey: ['queryRegistryOperatorConfiguration', offset, ledgerApi, operator],
    queryFn: async () => {
      return ledgerApi.queryRegistryOperatorConfiguration(offset!, operator);
    },
    enabled: !!offset,
    refetchInterval: false,
  });
};

export default useRegistryOperatorConfiguration;
